<template>
  <div v-if="show" :class="['payment-status', statusClass]">
    {{ statusDescription }}
  </div>
</template>

<script>
  import PaymentStatus from '@/models/enums/PaymentStatus'
  import DeliveryType from '@/models/enums/DeliveryType'
  import PaymentType from '@/models/enums/PaymentType'
  import PaymentMode from '@/models/enums/PaymentMode'
  import { formatNumAsString } from '@/util/num-format'
  import { getCurrencySymbol } from '@/util/money'

  export default {
    name: 'PaymentStatusTag',
    props: {
      order: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      payment () {
        return this.order?.payment
      },
      show () {
        if (this.paymentStatus === PaymentStatus.Success) {
          return true
        }

        if (this.payment?.type === PaymentType.Online) {
          return true
        }

        if (this.order.deliveryType !== DeliveryType.Delivery) {
          return true
        }

        // доставку с «оплатить сейчас» ждут в филиале - без тега не видно, что она не оплачена;
        // режим берём из платежа: в списке заказов у заказа поля paymentMode нет
        return this.payment?.mode === PaymentMode.PayNow
      },
      paymentStatus () {
        if (this.payment) {
          return this.payment?.status
        }
        return null
      },
      statusClass () {
        switch (this.paymentStatus) {
          case PaymentStatus.Success: return 'status-paid'

          case PaymentStatus.Cancel:
          case PaymentStatus.Refund: return 'status-cancel'

          default: return 'status-wait'
        }
      },
      statusDescription () {
        if (this.paymentStatus === PaymentStatus.Success) {
          return `${PaymentStatus.getName(this.paymentStatus)} ${formatNumAsString(this.payment.total) + getCurrencySymbol()}`
        }

        return PaymentStatus.getName(this.paymentStatus)
      },
    },
  }
</script>

<style lang="less" scoped>
.payment-status {
  padding: 0 16px;
  border-radius: 25px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  text-align: center;

  &.status-wait {
    background-color: @color-pink;
  }
  &.status-paid {
    background-color: @color-success;
  }
  &.status-cancel {
    background-color: @color-error;
  }

  @media (max-width: 1700px) {
    font-size: 13px;
  }
}
</style>
